export const sidebarPopoverSelector = (state) => state.sidebar.popover;

export const sidebarCollapsedSelector = (state) => state.sidebar.collapsed;
